export default "__VITE_ASSET__DnBazg5d__"